import { ApiProperty } from "@nestjs/swagger";

export class BomIdsRequest {
    @ApiProperty()
    packingMaterialId: number[];
    @ApiProperty()
    vendorId: number;
    @ApiProperty()
    unitId?: number;
    constructor(packingMaterialId: number[], vendorId: number, unitId?: number) {
        this.packingMaterialId = packingMaterialId;
        this.vendorId = vendorId;
        this.unitId = unitId;
    }
}